import React, { memo, forwardRef } from "react";
const SvgCapitalG = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M22.54 21.24c0 .427-.093.76-.28 1-.173.24-.473.433-.9.58a12.5 12.5 0 01-1.94.46c-.68.107-1.42.16-2.22.16-1.147 0-2.193-.18-3.14-.54a7.388 7.388 0 01-2.44-1.54 7.248 7.248 0 01-1.6-2.36c-.373-.92-.56-1.933-.56-3.04 0-1.133.193-2.153.58-3.06.4-.92.94-1.7 1.62-2.34a7.302 7.302 0 012.44-1.48c.933-.347 1.947-.52 3.04-.52.933 0 1.767.113 2.5.34.733.213 1.34.493 1.82.84.267.187.433.373.5.56.08.173.12.34.12.5 0 .347-.107.633-.32.86-.213.213-.48.32-.8.32-.12 0-.253-.02-.4-.06a1.61 1.61 0 01-.48-.24 5.964 5.964 0 00-1.24-.62c-.48-.187-1.04-.28-1.68-.28-.747 0-1.427.133-2.04.4a4.58 4.58 0 00-1.54 1.1 5.112 5.112 0 00-1 1.64 5.954 5.954 0 00-.34 2.04c0 .76.113 1.46.34 2.1.24.627.573 1.173 1 1.64.44.467.967.833 1.58 1.1.627.253 1.333.38 2.12.38 1.08 0 2.02-.167 2.82-.5v-3.6h-2c-.24 0-.44-.033-.6-.1a1.295 1.295 0 01-.36-.28c-.08-.12-.133-.24-.16-.36a1.43 1.43 0 01-.04-.3c0-.08.013-.18.04-.3a.882.882 0 01.16-.34.94.94 0 01.36-.28c.16-.08.36-.12.6-.12h3.02c.947 0 1.42.473 1.42 1.42v4.82z"
      />
    </svg>
  );
});
SvgCapitalG.displayName = "SvgCapitalG";
const MemoForwardRef = memo(SvgCapitalG);
export default MemoForwardRef;
